import React, { useState } from 'react';
import { View } from 'react-native';

import RelayTable from 'app/src/elements/Table/RelayTable';
import { Title, Text } from 'app/src/styles';
import { Link } from 'app/src/utils/routing';

import { MEDICINE_GROUPS } from './queries';

const columns = [
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'client',
    label: 'Client',
    value: ({ value }) => value.name,
  },
  {
    key: 'scheduledTime',
    label: 'Scheduled Time',
  },
  {
    key: 'medicines',
    label: 'Medicines',
    value: ({ value }) => value.map(m => m.name).join(', '),
  },
  {
    key: 'actions',
    sort: 'prevent',
    content: ({ entry }) => (
      <Link to={`/medicine-groups/${entry.id}`}>
        <Text>View/Edit</Text>
      </Link>
    ),
  },
];

const MedicineGroups = () => {
  const [refetch, setRefetch] = useState();

  return (
    <View>
      <Title>Medicine Groups</Title>

      <Link to="/medicine-groups/new">
        <Text>Add Medicine Group</Text>
      </Link>

      <RelayTable
        query={MEDICINE_GROUPS}
        queryName="medicineGroups"
        columns={columns}
        setRefetch={setRefetch}
      />
    </View>
  );
};

export default MedicineGroups;
